/**
* 
*/
<template>
  <div>
    <el-button
      size="small"
      type="primary"
      class="mb20"
      icon="el-icon-search"
      @click="add"
      >新增</el-button
    >
    <el-table
      size="small"
      :data="list"
      height="82vh"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column align="center" prop="IDX" label="序号">
      </el-table-column>
      <el-table-column
        align="center"
        prop="BannerPicURL"
        label="轮播图片"
        min-width="300"
      >
        <template slot-scope="scope">
          <el-image
            v-if="scope.row.BannerPicURL"
            style="width: 350px; height: 180px"
            :src="bannerUrl + scope.row.BannerPicURL"
            fit="contain"
          >
          </el-image>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            @click="handleEdit(scope.$index, scope.row)"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="text"
            @click="handleDelete(scope.$index, scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 编辑界面 -->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      width="60%"
      @close="closeDialog('edit')"
    >
      <el-form
        :model="editForm"
        :rules="rules"
        ref="editForm"
        label-width="100px"
        class="demo-editForm"
      >
        <el-form-item label="应用场景" prop="ApplicationScenariosType">
          <el-select
            v-model="editForm.ApplicationScenariosType"
            placeholder="请选择应用场景"
            @change="changeScenariosType"
          >
            <el-option label="账套" value="账套"></el-option>
            <el-option label="商铺" value="商铺"></el-option>
            <el-option label="分类" value="分类"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="商铺/分类"
          prop="ApplicationScenariosGUID"
          v-if="
            editForm.ApplicationScenariosType == '商铺' ||
            editForm.ApplicationScenariosType == '分类'
          "
          :rules="[
            { required: true, message: '请选择商铺/分类', trigger: 'change' },
          ]"
        >
          <el-select
            v-model="editForm.ApplicationScenariosGUID"
            placeholder="请选择商铺"
            v-if="editForm.ApplicationScenariosType == '商铺'"
          >
            <el-option
              v-for="item in shops"
              :key="item.guid"
              :label="item.name"
              :value="item.guid"
            ></el-option>
          </el-select>
          <el-select
            v-else
            v-model="editForm.ApplicationScenariosGUID"
            placeholder="请选择分类"
          >
            <el-option
              v-for="item in categoryList"
              :key="item.guid"
              :label="item.name"
              :value="item.guid"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="链接类型" prop="BannerLinkType">
          <el-select
            v-model="editForm.BannerLinkType"
            placeholder="请选择链接类型"
            @change="changeLinkType"
          >
            <el-option label="单品" value="单品"></el-option>
            <el-option label="专场" value="专场"></el-option>
            <el-option label="资讯" value="资讯"></el-option>
            <el-option label="商铺" value="商铺"></el-option>
            <el-option label="分类" value="分类"></el-option>
            <el-option label="盲盒" value="盲盒"></el-option>
            <el-option label="直播" value="直播"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="请选择商品"
          prop="BannerLinkGUID"
          v-if="
            editForm.BannerLinkType == '单品' ||
            editForm.BannerLinkType == '专场' ||
            editForm.BannerLinkType == '盲盒'
          "
          :rules="[
            { required: true, message: '请选择商品', trigger: 'change' },
          ]"
        >
          <el-select
            v-model="editForm.BannerLinkGUID"
            placeholder="请选择商品"
            filterable
            v-if="editForm.BannerLinkType == '单品'"
            @change="
              (v) => {
                changeGoods(v, 0);
              }
            "
          >
            <el-option
              v-for="(item, idx) in goodsList"
              :key="idx"
              :label="item.name"
              :value="item.guid"
            ></el-option>
          </el-select>

          <el-select
            v-model="editForm.BannerLinkGUID"
            placeholder="请选择专场"
            filterable
            v-if="editForm.BannerLinkType == '专场'"
            @change="
              (v) => {
                changeGoods(v, 0);
              }
            "
          >
            <el-option
              v-for="(item, idx) in specialList"
              :key="idx"
              :label="item.name"
              :value="item.guid"
            ></el-option>
          </el-select>

          <el-select
            v-model="editForm.BannerLinkGUID"
            placeholder="请选择盲盒"
            filterable
            v-if="editForm.BannerLinkType == '盲盒'"
            @change="
              (v) => {
                changeGoods(v, 1);
              }
            "
          >
            <el-option
              v-for="(item, idx) in specialList1"
              :key="idx"
              :label="item.name"
              :value="item.guid"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="链接:"
          prop="InformationLinkURL"
          v-if="editForm.BannerLinkType == '资讯'"
          :rules="[
            {
              required: true,
              message: '请复制文章链接到此处',
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            placeholder="复制文章链接到此处"
            prefix-icon="el-icon-search"
            v-model="editForm.InformationLinkURL"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="链接:"
          prop="BannerLinkGUID"
          v-if="editForm.BannerLinkType == '商铺' ||editForm.BannerLinkType == '分类'"
          :rules="[{ required: true, message: '请选择', trigger: 'change' }]"
        >
          <el-select
            v-model="editForm.BannerLinkGUID"
            placeholder="请选择商铺"
            @change="changeBannerLink"
            v-if="editForm.BannerLinkType == '商铺'"
          >
            <el-option
              v-for="item in shops"
              :key="item.ShopGUID"
              :label="item.ShopName"
              :value="item.ShopGUID"
            ></el-option>
          </el-select>
          <el-select
            v-if="editForm.BannerLinkType == '分类'"
            v-model="editForm.BannerLinkGUID"
            placeholder="请选择分类"
            @change="changeBannerLink"
          >
            <el-option
              v-for="item in categoryList"
              :key="item.CommodityTypeGUID"
              :label="item.CommodityTypeName"
              :value="item.CommodityTypeGUID"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="轮播图片" prop="BannerPicURL">
          <!-- <el-upload class="editor-upload" ref="upload" action="" :show-file-list="false" :limit="1"
            :auto-upload="false" :on-change="uploadImg">
            <div class="flex flex_end">
              <img v-if="editForm.BannerPicURL" :src="editForm.BannerPicURL" class="avatar" />
              <div v-else class="flex-all avatar relative">
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </div>
              <div slot="tip" class="el-upload__tip">
                说明：图片只允许上传一张
              </div>
            </div>
          </el-upload> -->

          <mupload
            :fileList="fileList"
            FilePath="images/Banner"
            uploadName="upload"
            :canUpload="true"
            @handleUpload="handleUpload"
            @handleRemove="handleRemoveFile"
          ></mupload>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('editForm')"
            >立即创建</el-button
          >
          <el-button @click="resetForm('editForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import mupload from "@/components/upload.vue";
let flag = true;
export default {
  components: { mupload },
  data() {
    return {
      goodsList: [],
      fileList: [],
      personInfo: {},
      bannerUrl: this.$bannerUrl,
      loading: false,
      editFormVisible: false,
      formInline: {
        InformationLinkTitle: "",
      },
      changeScenarios: [],
      list: [],
      editForm: {
        BannerPicURL: "",
        ActivityTypeName: "",
        bannerLinkType: "",
        InformationLinkURL: "",
        BannerLinkGUID: "",
        ApplicationScenariosGUID: "",
      },
      specialList: [],
      specialList1: [],
      selectedInfo: {},
      rules: {
        ApplicationScenariosType: {
          required: true,
          message: "请选择应用场景",
          trigger: "change",
        },
        BannerLinkType: {
          required: true,
          message: "请选择链接类型",
          trigger: "change",
        },
        BannerPicURL: {
          required: true,
          message: "请上传图片",
          trigger: "blur",
        },

        bannerLinkType: {
          required: true,
          message: "请输入标题",
          trigger: "blur",
        },
        link: { required: true, message: "请输入标链接", trigger: "blur" },
      },
      shops: [],
    };
  },
  mounted() {
    this.personInfo = JSON.parse(this.$util.getStore("personInfo"));
    this.getBannerList();
    this.getGoodsList();
    this.getShops();
    this.getCategoryList();
    this.getSpecialList("专场");
    this.getSpecialList("盲盒");
  },
  methods: {
    handleUpload(e) {
      console.log(e, 444);
      this.fileList = [e];
      this.editForm.BannerPicURL = e.name;
    },
    handleRemoveFile(e) {
      console.log(e, 30444);
      this.fileList = [];
      this.editForm.BannerPicURL = "";
    },
    changeScenariosType(e) {
      let { changeScenarios, editForm, shops, categoryList } = this,
        { ApplicationScenariosType } = editForm;
      if (ApplicationScenariosType == "商铺") {
        changeScenarios = shops;
      } else {
        changeScenarios = categoryList;
      }
      this.changeScenarios = changeScenarios;
      this.editForm.ApplicationScenariosType = e;
      this.editForm.ApplicationScenariosGUID = "";
    },
    changeScenariosGUID(e, i) {
      console.log(e, 3744);

      this.editForm.ApplicationScenariosGUID = e;
    },
    changeLinkType(e) {
      console.log(e, 150);
      this.editForm.BannerLinkType = e;
    },
    changeGoods(e, i) {
      console.log(e, 37666);
      this.editForm.BannerLinkGUID = e;
    },
    changeBannerLink(e) {},
    getCategoryList(e) {
      let categoryList = [];
      let sqlCmdName = "ShopWebApp\\GetCommodityTypeList_1_0_1";
      let data = {
        CompanyGUID: this.personInfo.CompanyGUID,
      };
      this.$loading();
      this.$api.QueryDataFn(sqlCmdName + "&DBC=r_m", data).then((res) => {
        this.$loading().close();
        let result = res.data;
        if (result.OK != "True") {
          this.$message.error(result.Message);
        } else if (result.Tag.length == 0) {
          this.$message.error("暂无分类数据");
        } else {
          categoryList = result.Tag[0].Table;
          categoryList.forEach((item) => {
            item.guid = item.CommodityTypeGUID;
            item.name = item.CommodityTypeName;
          });
        }
        this.categoryList = categoryList;
      });
    },
    getGoodsList(searchName) {
      let goodsList = [];
      let sqlCmdName = "ShopWebApp\\GetAllCommoditys_1_0_1";
      let data = {
        CommodityName: "",
        CompanyGUID: this.personInfo.CompanyGUID,
        ShopGUID: "",
      };
      this.$loading();
      this.$api.QueryDataFn(sqlCmdName + "&DBC=r_m", data).then((res) => {
        this.$loading().close();
        let result = res.data;
        if (result.OK != "True") {
          this.$message.error(result.Message);
        } else if (result.Tag.length == 0) {
          this.$message.error("暂无相关商品数据");
        } else {
          goodsList = result.Tag[0].Table;
          goodsList.forEach((item) => {
            item.guid = item.CommodityGUID;
            item.name = item.CommodityName;
          });
        }
        

        this.goodsList = goodsList;
      });
    },

    getSpecialList(e) {
      let specialList = [];
      let sqlCmdName =
        e == "盲盒"
          ? "ShopWebApp\\GetAllBlindBox_1_0_1,ShopWebApp\\GetBlindBoxCommoditys_1_0_1"
          : "ShopWebApp\\GetAllSpecialSession_1_0_1,ShopWebApp\\GetSpecialSessionCommoditys_1_0_1";
      let data = {
        CompanyGUID: this.personInfo.CompanyGUID,
      };
      this.$loading();
      this.$api.QueryDataFn(sqlCmdName + "&DBC=r_m", data).then((res) => {
        this.$loading().close();
        let result = res.data;
        if (result.OK != "True") {
          this.$message.error(result.Message);
        } else if (result.Tag.length == 0) {
        } else {
          specialList = result.Tag[0].Table;
          
        }
        if (e == "盲盒") {
          specialList.forEach((item) => {
            item.guid = item.BlindBoxGUID;
            item.name = item.BlindBoxName;
          });
          this.specialList1 = specialList;
        } else {
          specialList.forEach((item) => {
            item.guid = item.SpecialSessionGUID;
            item.name = item.SpecialSessionName;
          });
          this.specialList = specialList;
        }
      });
    },
    getShops() {
      let data = {
          CompanyGUID: this.personInfo.CompanyGUID,
        },
        info = [];
      let sqlCmdName = "ShopWebApp\\GetShopList_1_0_1";

      this.$loading();
      this.$api.QueryDataFn(sqlCmdName + "&DBC=r_m", data).then((res) => {
        this.$loading().close();
        let result = res.data;
        if (result.OK != "True") {
          this.$message.error(result.Message);
        } else if (result.Tag.length == 0) {
          this.$message.error("暂无相关商铺数据");
        } else {
          info = result.Tag[0].Table;
          info.forEach((item) => {
            console.log(item,498)
            item.guid = item.ShopGUID;
            item.name = item.ShopName;
          });
          this.shops = info;
        }
      });
    },
    getBannerList(guid) {
      let sqlCmdName = guid
        ? "ShopWebApp\\GetCompanyBannerList_1_0_1"
        : "ShopWebApp\\GetBannerList_1_0_1";

      let data = {
        CompanyGUID: this.personInfo.CompanyGUID,
      };
      this.$loading();
      this.$api.QueryDataFn(sqlCmdName + "&DBC=r_m", data).then((res) => {
        let result = res.data;
        this.$loading().close();
        let bannerList = [];
        if (result.OK != "True") {
          this.$message.error(result.Message);
        } else if (result.Tag.length == 0) {
          this.$message.error(result.Message);
        } else {
          bannerList = result.Tag[0].Table;
        }
        this.list = bannerList;
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log("valid", valid, this.editForm);
          this.submitTap();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    submitTap: function () {
      let that = this;
      let {
        BannerLinkType,
        BannerPicURL,
        BannerLinkGUID,
        InformationLinkURL,
        BannerGUID,
        ApplicationScenariosGUID,
      } = that.editForm;
      console.log(22222, BannerLinkType, BannerLinkGUID);
      if (!BannerPicURL || BannerPicURL == "") {
        this.$message("banner图片不能为空");
        return;
      }
      if (
        BannerLinkType == "单品" ||
        BannerLinkType == "专场" ||
        BannerLinkType == "盲盒"
      ) {
        if (BannerLinkGUID == "") {
          this.$message("请选择对应的" + BannerLinkType);
          return;
        }
      } else if (BannerLinkType == "商铺" || BannerLinkType == "分类") {
        console.log("ApplicationScenariosGUID:", ApplicationScenariosGUID);
        if (ApplicationScenariosGUID == "") {
          this.$message("请选择对应的" + BannerLinkType);
          return;
        }
      } else {
        if (InformationLinkURL == "" && BannerLinkType == "资讯") {
          this.$message("资讯链接不能为空");
          return;
        }
      }
            console.log(BannerGUID,111)
      if (flag) {
        flag = false;
        if (BannerGUID&&BannerGUID != "") {
          that.releaseBanner(BannerGUID);
        } else {
          this.$api.returnGuid().then(guid=>{
            console.log(guid,111)
              that.releaseBanner(guid);
          })
        }
      }
    },

    releaseBanner: function (BannerGUID) {
      let that = this;
      let {
        BannerLinkType,
        BannerLinkGUID,
        BannerPicURL,
        InformationLinkURL,
        ApplicationScenariosType,
        ApplicationScenariosGUID,
      } = that.editForm;
      let data = [
        {
          BannerGUID,
          BannerPicURL,
          BannerLinkType,
          BannerLinkGUID,
          InformationLinkURL,
          CompanyGUID: this.personInfo.CompanyGUID,
          ApplicationScenariosType,
          ApplicationScenariosGUID,
        },
      ];
      this.loading = true;
      this.$api
        .ExSqlFn("ShopWebApp\\UpdateBanner_1_0_1&DBC=w_m", data)
        .then((res) => {
          this.loading = false;
          let result = res.data;
          console.log(result);
          this.editFormVisible = false;
          flag = true;

          if (result.OK != "True") {
            this.$message.error(result.Message);
          } else if (result.Tag[0] < 1) {
            this.$message.error("提交失败");
          } else {
            this.$message.success("提交成功");

            this.$refs["editForm"].resetFields();
            this.fileList=[]
            this.getBannerList();
          }
        });
    },
    add() {
      this.editFormVisible = true;
    },
    search() {},
    handleEdit(index, row) {
      this.editFormVisible = true;
      this.getBannerDetail(row.BannerGUID);
    },

    //获取轮播图明细
    getBannerDetail: function (BannerGUID) {
      let sqlCmdName = "ShopWebApp\\GetBannerInfo_1_0_1";
      let data = {
          BannerGUID,
        },
        bannerDetail = {};
      this.$loading();
      this.$api.QueryDataFn(sqlCmdName + "&DBC=r_m", data).then((res) => {
        let result = res.data;
        this.$loading().close();
        if (result.OK != "True") {
          this.$message.error(result.Message);
        } else if (result.Tag.length == 0) {
          this.$message.error("获取失败");
        } else {
          bannerDetail = result.Tag[0].Table[0];
          if (bannerDetail.BannerPicURL != "") {
            let obj = {
              url: this.bannerUrl + bannerDetail.BannerPicURL,
              name: bannerDetail.BannerPicURL,
            };
            this.fileList = [obj];
          }
        }
        console.log(bannerDetail, 666);
        this.editForm = bannerDetail;
      });
    },
    handleDelete(index, row) {
      console.log(row, 273);
      this.$confirm("此操作将删除图片, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.delTap(row.BannerGUID);
        })
        .catch(() => {});
    },

    delTap: function (BannerGUID) {
      let sqlCmdName = "ShopWebApp\\DeleteBanner_1_0_1&DBC=w_m";
      let data = [
        {
          BannerGUID,
          CompanyGUID: this.personInfo.CompanyGUID,
        },
      ];
      this.$loading();
      this.$api.ExSqlFn(sqlCmdName, data).then((res) => {
        this.$loading().close();
        let result = res.data;
        if (result.OK != "True") {
          this.$message(result.Message);
        } else {
          this.$message("删除成功");
          this.getBannerList();
        }
      });
    },
  },
};
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/views/shop/upLoop.vue